import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import { selectedWindowChanged } from '../windows/windowsSlice';

import WallView from './WallView';
import SingleTraceView from '../singleTraceView/SingleTraceView';

import { analyzerChanged } from '../analyzers/analyzerSlice';

import { toggleSingleTraceView } from './wallsSlice';
import useReconnectToAnalyzers from './hooks/useReconnectToAnalyzers';

import { useAnalyzers } from 'features/analyzers/api/getAnalyzers';
import { useWindows } from 'features/windows/api/getWindows';
import { useWindow } from 'features/windows/api/getWindow';
import { useNavigate } from 'react-router-dom';

const Wall = () => {
  const params = useParams();
  const navigate = useNavigate();
  const wallId = Number(params.wallId);
  const { user } = useAppSelector((state) => state.auth);

  const dispatch = useAppDispatch();
  const selectedAnalyzerId = useAppSelector(
    (state) => state.analyzers.selectedAnalyzerId
  );
  const { inSingleTraceView } = useAppSelector((state) => state.walls);
  const selectedWindowId = useAppSelector(
    (state) => state.windows.selectedWindowId
  );

  const { data: windows } = useWindows({ wallId });
  const { data: analyzers } = useAnalyzers({});
  const { data: selectedWindow } = useWindow({ windowId: selectedWindowId });

  useReconnectToAnalyzers({ windows, user, wallId });

  const openSingleTraceView = (row: number, column: number) => {
    const window = windows?.find(
      (window) => window.pos_x === row && window.pos_y === column
    );

    if (window === undefined) return;

    dispatch(selectedWindowChanged(window.id));
    dispatch(analyzerChanged(window.analyzer_id));

    if (window.trace_mode === 2) {
      navigate(`/trendline/${window.snapshot_id}`);
    } else {
      dispatch(toggleSingleTraceView(true));
    }
  };

  if (!analyzers || analyzers?.length === 0) return <></>;

  return (
    <div style={{ marginTop: '-20px' }}>
      <Grid container style={{ paddingBottom: '1.5rem' }}>
        {inSingleTraceView && selectedWindow ? (
          <SingleTraceView
            selectedAnalyzerId={selectedAnalyzerId}
            selectedSnapshotId={selectedWindow?.snapshot_id}
            traceMode={selectedWindow?.trace_mode || 0}
            wallId={wallId}
          />
        ) : (
          <WallView
            selectedWallId={wallId}
            openSingleTraceView={openSingleTraceView}
          />
        )}
      </Grid>
    </div>
  );
};

export default Wall;
